import { render } from "./AttacheesVolunteers.vue?vue&type=template&id=2cd904ce&scoped=true"
import script from "./AttacheesVolunteers.vue?vue&type=script&lang=js"
export * from "./AttacheesVolunteers.vue?vue&type=script&lang=js"

import "./AttacheesVolunteers.vue?vue&type=style&index=0&id=2cd904ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd904ce"]])

export default __exports__